module.exports = __webpack_public_path__ + "static/media/26.40449e3f.svg";